module.exports = __webpack_public_path__ + "img/three1Orange.965a1c64.jpg";